
const order = {
    tableNumber: null,
    phone: null,
    menuId: null,
    dishes: [
    //     {
    //         id: "unId",
    //         qty: 2,
    //         prc: '8.00'
    //     }
    ]
  };
window.order = order;



function arraySum(array){
    const $total = $('#total');

    // console.log(array.length);

    let sum = 0;
    for(let i = 0; i < array.length; i++){
        sum += array[i];
    }
    // console.log(sum);

    $total.text(sum.toFixed(2))
}

function nextStep(el){
    const $parent = $(el).closest('.steps__item');
    if($parent){
        $parent.removeClass('active');
        $parent.next('.steps__item').addClass('active');
    }
}

function setCurrentSum(){
    const $items = $('#orderTable tr[data-unid] .pricefield');
    const totalSum = [];
    $.each($items, function(i, el){
        const num = +($(el).text());
        totalSum.push(num);
    });
    // console.log(totalSum);
    arraySum(totalSum);
}

function setTotalIncr(){
    // write to increment total
    const $cartBtn = $('#cart-btn');
    const $totalIncr = $('#cart-btn .num');
    const $allOrders = $('#menu li .num');
    const allOrdersArray = [];

    $.each($allOrders, function(i,el){
        allOrdersArray.push(+($(el).text()));
    });
    let sum = 0;
    for(let i = 0; i < allOrdersArray.length; i++){
        sum += allOrdersArray[i];
    }

    // console.log(sum);
    // $totalIncr.text(sum);


    if($('.incr', $cartBtn).length){
        $($totalIncr).text(sum);
    } else if(sum > 0) {
        $($cartBtn).append(`<span class="incr"><sub>x</sub><span class="num">${sum}</span></span>`);
    }
    if(sum <= 0) {
        $('.incr').remove();
    }
}


function countSum(id) {
    const $item = $(`#orderTable tr[data-unid="${id}"]`);
    const value = +($($('.quantity__input', $item)).val());
    const price = +($($item).attr('data-price'));
    const subtotal = (value * price).toFixed(2);
    const $priceField = $('.pricefield', $item);

    // write to increment menu item
    const $firstStepItem = $(`#menu li[data-unid="${id}"] .num`);
    $firstStepItem.text(value);

    setTotalIncr();

    $priceField.text(subtotal);

    // console.log(id);

}


$(document).on('input', '.quantity__input', function(){
    const dataId = $(this).closest('tr').attr('data-unid');
    countSum(dataId);
    setCurrentSum()
})

$(document).on('click', '.btn-remove', function(){
    const targetId = $(this).closest('tr').attr('data-unid');
    const $firstStepItemIncr = $(`#menu li[data-unid="${targetId}"] .incr`);

    for (let i = 0; i < order.dishes.length; i++) {
        const obj = order.dishes[i];

        if (obj.id === targetId) {
            order.dishes.splice(i, 1);
        }
    }
    // console.log("After delete: ", order.dishes);

    // console.log($firstStepItemIncr);

    $($firstStepItemIncr).remove();
    setTimeout(() => {
        setTotalIncr();
        setCurrentSum();
    }, 100);

    $(this).closest('tr').slideUp().remove();
})

$(document).on('input', '#tableNum', function(){
    $(this).removeClass('error');
    order.tableNumber = $(this).val();

})

$(document).on('input', '#phone', function(){
    $(this).removeClass('error');
    order.phone = $(this).val();

})

$(document).on('click', '.js-to-order-slide', function(){
    const $parent = $(this).closest('.steps__item');
    const $orderSlide = $('.steps__item.steps__item_order');

    if($parent){
        $parent.removeClass('active');
        $orderSlide.addClass('active');
    }
})
$(document).on('click', '.js-to-first-slide', function(){
    const $parent = $(this).closest('.steps__item');
    const $firstSlide = $('.steps__item:first-child');

    if($parent){
        $parent.removeClass('active');
        $firstSlide.addClass('active');
    }
})


function btnsClick(){
    const $btns = $('.menu__btn');

    if($btns.length > 0){
        $.each($btns, function(i,el){
            $(el).on('click', function(){
                const $cartBtn = $('#cart-btn');
                if($('.incr', $(this)).length ){
                    let inkr = +($('.incr .num', $(this)).text());
                    // console.log(inkr);
                    if(inkr > 0 && inkr !== 'undefined'){
                        inkr += 1;
                        $('.incr .num', $(this)).text(inkr);
                    }

                } else {
                    $(this).append('<span class="incr"><sub>x</sub><span class="num">1</span></span>')

                }

                if($cartBtn.length > 0 ){
                    setTotalIncr();
                }

            })
        })
    }

}



function setTotal(){

    // console.log(order);
    const countPrices = order.dishes;
    const toSum = [];

    for (let index = 0; index < countPrices.length; index++) {
        const element = countPrices[index];
        const price = element.prc * element.qty;
        toSum.push(price);

    }
    arraySum(toSum);

}

function setOrderTable(){
    const $parent = $('#menu');
    const $item  = $('li', $parent);
    const $table = $('#orderTable');
    const dishes = [];

    if($item.length > 0){
        $.each($item, function(i,el){

            if($('.incr', el).length){
                const unId = $(el).attr('data-unId');
                const price = +($(el).find('.value').text());
                const qty = +($(el).find('.incr .num').text());
                const priceResult = price * qty;
                const name = $('.menu__product', el).attr('data-name');

                $table.append(`<tr data-unId="${unId}" data-price="${price}"><td>${name}</td><td><div class="order__quantity quantity"><input class="quantity__input" type="number" name="${name}" value="${qty}"><div class="quantity__btns"></div></div></td><td><div class="order__price"><span class="price"><span class="current">€</span><span class="pricefield">${priceResult.toFixed(2)}</span></span><div class="btn-remove"><img src="/img/x-circle.svg" alt="remove product"></div></div></td></tr>`);

                dishes.push({'id': unId, 'qty': qty, 'prc': price});
            }
        });

        window.order.dishes = dishes;
        console.log(dishes);

        setTotal();

        // console.log(dishes);

    }
}

function toOrderStep(){
    const $cartBtn = $('#cart-btn');
    $cartBtn.on('click', function(e){
        if(!$('.incr', $cartBtn).length){
            return;
        }

        nextStep($cartBtn);

        setOrderTable();

    })
}




function clearCart() {
    const $counters = $(`.incr`);

    // console.log($counters);

    $($counters).remove();

    setTimeout(() => {
        setTotalIncr();
        setCurrentSum();
    }, 100);

    $('#orderTable tbody tr').slideUp().remove();
}


function confirm(){
    const $target = $('.order-confirm');
    const $tableNum = $('#tableNum');
    const menuAttrId = $('#menu').attr('data-menu-unid');
    $target.on('click', function(){
        if($($tableNum).val() === ''){
            $($tableNum).addClass('error');
        } else {
            $($tableNum).removeClass('error');

            console.log(order);
            order.menuId = menuAttrId;

            $.ajax({
                // url:   '/api/generator?lang=',
                url:   `/api/menu/${  order.menuId  }/orders`,
                type:     "POST",
                dataType: "Json",
                data: {
                    order
                },
                success(response) {
                    nextStep($('.order-confirm'));
                    clearCart(); // clear the list once the order has been submitted
                },
                error(response) {
                    $('.steps__item_order').removeClass('active');
                    nextStep($('.js-done-btn'));
                    // console.log(order);
                }

            });
        }
    });
}


btnsClick();
toOrderStep();
confirm();

/* Hamburger Menu and switcher */
$('.hamburger').click(function() {
    $('nav').toggleClass('closed', 0, 'linear');
    $('.dropdown').toggleClass('closed', 0, 'linear');
});
$('nav li a').click(function() {
    $('nav').toggleClass('closed', 0, 'linear');
    $('.dropdown').toggleClass('closed', 0, 'linear');
});



/**
 * Automatically open the hamburger menu when opening the page
 */
setTimeout(function(){
    $('nav').removeClass('closed', 0, 'linear');
    $('.dropdown').addClass('closed', 0, 'linear');
}, 1000);


/**
 * TEMP HARDCODED CODE:
 * Custom, hardcoded check for only "Galjoen Shop" menu
 * With this code, we make sure that all the dishes, under category "Bakkerij" can not be ordered on Monday
 * because the bakery is closed on Tuesday
 */
function bakeryTimeSlotInvalid(){
    const $closedDays = [0, 1];
    const $time = {day: 6, hour: 17, min: 15};

    const $date = new Date();
    const $today = $date.getDay();
    const $hour = $date.getHours();
    const $min = $date.getMinutes();

    return $closedDays.includes($today) ||
        ($today === $time.day && (($hour === $time.hour && $min >= $time.min) || $hour > $time.hour));
}

function canBuyBakery(){
    /* following is the ID of "Bakkerij" category of Galjoen Shop */
    const $bakkerij = $('#34d358bc-f7a5-4eeb-985e-712d08955fdd');
    const $buyButtons = $bakkerij.find('.menu__btn');

    // deactivate "buy" button for bakery items if the bakery is closed
    $.each($buyButtons, function( index, value ) {
        if(bakeryTimeSlotInvalid()) {
            const $txt = $(value).text();
            $(value).replaceWith(`<span>${ $txt }</span>`);
        }
    });
    /* add a warning message for the clients to the Bakkerij category */
    if(bakeryTimeSlotInvalid()) {
        $bakkerij.find('.categogory-title').after(
            '<p style="text-align: center;padding: 10px 0;">' +
            'Opgelet, op <strong>maandag en zondag</strong> kan er geen brood besteld worden.' +
            '</p>'
        )
    }
    else {
        $bakkerij.find('.categogory-title').after(
            '<p style="text-align: center;padding: 10px 0;">' +
            'Opgelet, bakkerij bestellingen geplaatst voor 18:00 kunnen <strong>morgen vanaf 9:00</strong> opgehaald worden.' +
            '</p>'
        )
    }
}
/** /END TEMP HARDCODED CODE */





$(document).ready(function(){
    $('.js-back').on('click', function(){
        const $parent = $(this).closest('.steps__item');

        if($parent){
            $parent.removeClass('active');
            $parent.prev('.steps__item').addClass('active');
        }
        $('#orderTable tbody *').remove();
    });


    /** TEMP HARDCODED */
    canBuyBakery(); // 0 = Sunday, 1 = Monday
    /** /END TEMP HARDCODED */
});


